/**
 * Eingabe von Beträgen, Mengen und Prozenten in deutscher Schreibweise. „1.234,56“, „1234,56“ und „1234.56“ ergeben dasselbe. Die Rechnung selbst steht in
 * packages/shared (offerTotals), hier geht es nur um das Umwandeln zwischen Eingabefeld und ganzen Zahlen.
 */

function toNumber(text: string): number | null {
  let t = text.trim().replace(/\s|€|%/g, '');
  if (!t) return null;
  // Mit Komma ist der Punkt ein Tausendertrenner, sonst ein Dezimalpunkt
  if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.');
  if (!/^-?\d*(\.\d*)?$/.test(t) || t === '-' || t === '.') return null;
  const n = Number(t);
  return Number.isFinite(n) ? n : null;
}

/** „35,00“ → 3500 Cent, null bei ungültiger Eingabe */
export const parseCents = (text: string): number | null => {
  const n = toNumber(text);
  return n === null ? null : Math.round(n * 100);
};

/** „1,5“ → 1500 Tausendstel */
export const parseMilli = (text: string): number | null => {
  const n = toNumber(text);
  return n === null ? null : Math.round(n * 1000);
};

/** „12,5“ → 1250 Basispunkte */
export const parseBp = (text: string): number | null => {
  const n = toNumber(text);
  return n === null ? null : Math.round(n * 100);
};

const plain = (n: number, digits: number) => new Intl.NumberFormat('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: digits, useGrouping: false }).format(n);

/** Für Eingabefelder: 3500 → „35,00“ */
export const centsText = (cents: number): string => plain(cents / 100, 2);
/** 1500 → „1,5“ */
export const milliText = (milli: number): string => new Intl.NumberFormat('de-DE', { maximumFractionDigits: 3, useGrouping: false }).format(milli / 1000);
/** 1250 → „12,5“, 0 → „“ */
export const bpText = (bp: number): string => (bp ? new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2, useGrouping: false }).format(bp / 100) : '');
